import {useTranslation} from 'react-i18next'
import {Tag} from '@/components/ui/tag'
import {CeldaEstado} from '@/components/ui/celdas-tabla'
import {type Column} from '@/components/data-table'
import {SUBSCRIPTION_ESTADO_TONE, type AdminSubscription} from '@/hooks/inci/cartera/use-cartera'

const dateFormat = new Intl.DateTimeFormat('es-CO', {year: 'numeric', month: 'short', day: 'numeric'})

export function useSuscripcionCicloEstadoPeriodoColumns(): Column<AdminSubscription>[] {
  const {t} = useTranslation()
  return [
    {
      key: 'ciclo',
      header: t('cartera.suscripciones.table.ciclo'),
      width: 'w-24',
      cell: (row) => <span className="text-sm text-foreground">{t(`cartera.precios.${row.billing_cycle}`)}</span>,
    },
    {
      key: 'estado',
      header: t('cartera.suscripciones.table.estado'),
      width: 'w-32',
      cell: (row) => (
        <CeldaEstado
          chip={<Tag tone={SUBSCRIPTION_ESTADO_TONE[row.estado]}>{t(`cartera.estado.${row.estado}`)}</Tag>}
        />
      ),
    },
    {
      key: 'periodo',
      header: t('cartera.suscripciones.table.periodo'),
      width: 'w-40',
      cell: (row) => (
        <span className="block truncate font-mono text-xs text-muted-foreground">
          {dateFormat.format(new Date(row.period_start))} – {dateFormat.format(new Date(row.period_end))}
        </span>
      ),
    },
  ]
}
